import axiosClient from '../axiosClient';

const packAPI = {
    async getListPackAPI(params) {
        const url = `/pack`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async updateStatusConfirm(id, data) {
        const url = `/pack/${id}`;
        const resp = await axiosClient.put(url, data);
        return resp;
    },
    async getListPackAPI_UserUsing(id, params) {
        const url = `/pack/check_user_using_pack/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getListPackAPI_HistoryUserUsing(id, params) {
        const url = `/pack`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async deposit(body) {
        const url = `/pack/deposit`;
        const resp = await axiosClient.post(url, body);
        return resp;
    },
    async addNewCardAPI(body) {
        const url = `/pack/create_multiple`;
        const resp = await axiosClient.post(url, body);
        return resp;
    },
    async submitPackAPI(body) {
        const url = `/pack/submit`;
        const resp = await axiosClient.post(url, body);
        return resp;
    },
};

export default packAPI;
